<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-row">
                <div class="form-group col-md-8">
                    <label for="name">Name</label>
                    <input id="name" class="form-control" [(ngModel)]="data.Name" name="name" />
                </div>
                <div class="form-group col-md-8">
                    <label for="email">Email</label>
                    <input id="email" class="form-control" [(ngModel)]="data.Email" name="email" />
                </div>
                <div class="form-group col-md-8">
                    <label for="password">Password</label>
                    <input id="password" class="form-control" [(ngModel)]="data.Password" name="password" (change)="validatePassword()"/>
                </div>
            </div>
            <div class="error-message" *ngIf="passwordErrors.length">The password must be at least 8 characters</div>
            <div class="error-message" *ngIf="passwordErrors.upper">The password must contain an upper case letter</div>
            <div class="error-message" *ngIf="passwordErrors.lower">The password must contain a lower case letter</div>
            <div class="error-message" *ngIf="passwordErrors.other">The password must contain a number or symbol</div>
        </form>
    </div>
    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <!-- <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="moveStudentToNewClass()">Move</button> -->
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting"></app-loading-spinner>
    </div>
</ng-template>

<a (click)="openForNew()">
   <u>CREATE ACCOUNT</u>
</a>